/*
 * Hero opening: the title uncovers word by word while the background image
 * settles out of its overscale into the rounded frame. Held until fonts are
 * ready so the word masks are measured against the real typeface.
 */

export default function initHeroIntro() {
	const hero = document.querySelector('.section--hero')
	if (!hero) return

	const start = () => {
		requestAnimationFrame(() => hero.classList.add('is-hero-in'))
	}

	if (document.fonts && document.fonts.ready) {
		document.fonts.ready.then(start).catch(start)
	} else {
		start()
	}
}
